import { Link } from "react-router-dom";
import { Instagram, Twitter, Linkedin, Facebook } from "lucide-react";

const socials = [
  { icon: Instagram, href: "https://www.instagram.com/ezsywebs/", label: "Instagram" },
  { icon: Twitter, href: "https://x.com/EzsyWebs", label: "X (Twitter)" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/ezsy-webs/", label: "LinkedIn" },
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61566009779591&sk", label: "Facebook" },
];

const Footer = () => {
  const serviceLinks = [
    { label: "How It Works", to: "/how-it-works" },
    { label: "Pricing", to: "/pricing" },
    { label: "Insights Report", to: "/insights" },
  ];

  const companyLinks = [
    { label: "About", to: "/about" },
    { label: "FAQ", to: "/faq" },
    { label: "Contact", to: "/contact" },
    { label: "Insights Report", to: "/insights" },
  ];

  const legalLinks = [
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Terms of Service", to: "/terms" },
    { label: "Cookie Policy", to: "/cookies" },
  ];

  return (
    <footer className="border-t border-border bg-background section-padding py-12 lg:py-16">
      <div className="container-narrow">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block">
              <p className="font-heading text-xl font-extrabold text-foreground">
                Ezsy<span className="text-accent"> Webs</span>
              </p>
            </Link>
            <p className="body-md mt-3 max-w-xs text-sm">
              Website refresh service for contractors, law firms, landscapers, clinics, and local service businesses across Canada and the United States. Fixed pricing, 14-day turnaround, SEO-safe process.
            </p>
            <a href="mailto:hello@ezsywebs.com" className="mt-4 block text-xs text-muted-foreground hover:text-accent transition-colors">
              hello@ezsywebs.com
            </a>
            <div className="mt-5 flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:border-accent hover:text-accent"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-sm font-bold uppercase tracking-wider text-foreground">Services</p>
            <ul className="mt-4 space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-bold uppercase tracking-wider text-foreground">Company</p>
            <ul className="mt-4 space-y-3">
              {companyLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm font-bold uppercase tracking-wider text-foreground">Legal</p>
            <ul className="mt-3 space-y-3">
              {legalLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-bold uppercase tracking-wider text-foreground">Service Area</p>
            <p className="mt-4 text-sm text-muted-foreground">Canada and United States</p>
            <p className="mt-2 text-sm text-muted-foreground">Serving contractors, landscapers, law firms, clinics, and local service businesses with existing websites.</p>
            <div className="mt-6">
              <Link
                to="/apply"
                className="inline-flex items-center text-sm font-semibold text-accent hover:underline"
              >
                Get a Free Homepage Preview →
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Ezsy Webs. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            Complex projects? We refer to{" "}
            <a href="https://www.ignitedigitalpartners.com/" target="_blank" rel="noopener noreferrer" className="text-accent underline">
              Ignite Digital Partners
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;